<template>
  <button
    :class="[
      'inline-flex items-center justify-center px-4 py-1.5 text-sm font-medium border border-transparent rounded-md focus:outline-none',
    ]"
  >
    <slot> <span>close </span></slot>
  </button>
</template>
